import type { EmployeeAbsenceRequest } from "@/lib/employeeAbsences";
import type { CurrentUser } from "@/lib/auth";

export const VACATION_WISH_DISMISS_KEY = "eh-vacation-wish-dismissed-date";

export function todayIsoLocal(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function isDevVacationSimulated(user: CurrentUser | null | undefined): boolean {
  return !!user?.dev_simulate_vacation;
}

/** Genehmigter oder ausstehender Urlaub, der den heutigen Tag abdeckt. */
export function isOnUrlaubToday(absences: EmployeeAbsenceRequest[]): boolean {
  const today = todayIsoLocal();
  return absences.some((req) => {
    if (req.absence_type !== "urlaub") return false;
    if (req.status === "rejected" || req.status === "cancelled") return false;
    const from = req.date_from.slice(0, 10);
    const to = req.date_to.slice(0, 10);
    return today >= from && today <= to;
  });
}

export function isVacationWishDismissedToday(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(VACATION_WISH_DISMISS_KEY) === todayIsoLocal();
  } catch {
    return false;
  }
}

export function dismissVacationWishForToday(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(VACATION_WISH_DISMISS_KEY, todayIsoLocal());
  } catch {
    // ignore
  }
}

const VACATION_WISHES = [
  (name: string) =>
    `${name}, wir wünschen dir erholsame Tage – Zeit zum Entspannen und Auftanken.`,
  (name: string) =>
    `Genieße deine Auszeit, ${name}. Wir freuen uns auf deine Rückkehr.`,
  (name: string) =>
    `${name}, dir einen wunderschönen Urlaub voller Ruhe und kleiner Freuden.`,
  (name: string) =>
    `Urlaub ist da – ${name}, gönn dir die Pause. Wir halten hier alles im Blick.`,
  (name: string) =>
    `${name}, wir wünschen dir sonnige Momente und eine rundum gute Erholung.`,
  (name: string) =>
    `Ein warmer Gruß in die Ferne: ${name}, hab eine schöne Zeit.`,
  (name: string) =>
    `${name}, dir einen Urlaub, der dir gut tut – wir sind gespannt auf deine Geschichten.`,
];

export function pickVacationWishMessage(displayName: string): string {
  const name = displayName.trim() || "Du";
  const index = new Date().getDate() % VACATION_WISHES.length;
  return VACATION_WISHES[index]!(name);
}
